import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/rupee.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import rcptIcon from '../images/rcpticon.png';
import { data } from "react-router";
import CustomerDiv from "../common/customerdiv";
import Select from "react-select";
const Payments=()=>
{
    const [show,setShow]=useState(false);
    const [tdsstatus,setTDSStatus]=useState(true);
    const [msg,setMsg]=useState("");
    const [paymentdata,setPaymentData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({id:0,facilityid:0,subscriberid:0,accountheadid:0,paymentdate:"",amount:0,tds:0,transactiontype:"",details:""});
    const [subscribers,setSubscribers]=useState([]);
    const [accountheads,setAccountHeads]=useState([]);
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [progress,setProgress]=useState(false);
    const [startDate,setStartDate]=useState(new Date(new Date().setDate(1)).toISOString().split('T')[0]);
    const [endDate,setEndDate]=useState(new Date().toISOString().split("T")[0]);
    const [facilities,setFacilities]=useState([]);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Customer Details", key: "customer", sortable: true},
        { name: "Account Head", key: "accounthead", sortable: true },        
        { name: "Transaction Date", key: "tdate", sortable: true },
        { name: "Debit/Credit", key: "ttype", sortable: true },
        { name: "Amount", key: "amount", sortable: true},      
        { name: "Details", key: "tdetails", sortable: true},        
    ];
    function addSubsriber(event)
    {
        setFormData({id:0,facilityid:0,subscriberid:0,accountheadid:0,paymentdate:"",amount:0,tds:0,transactiontype:"",details:""});
        setShow(true);
    }
    async function saveData(event)
    {
        if(formData.subscriberid=="0" || formData.subscriberid=="")
        {
            setMsg("Select Customer!!!!");
            return;
        }
        if(formData.accountheadid=="0" || formData.accountheadid=="")
        {
            setMsg("Select Account Head!!!!");
            return;
        }
        if(formData.paymentdate=="")
        {
            setMsg("Payment Date is Missing!!!!");
            return;
        }
        if(isNaN(parseFloat(formData.amount)) || parseFloat(formData.amount)<=0)
        {
            setMsg("Invalid Amount!!!!");
            return;
        }
        if(formData.transactiontype=="0" || formData.transactiontype=="")
        {
            setMsg("Select Transaction Type!!!");
            return;
        }
        if(formData.accountheadid=="2" && formData.tds!="")
        {
            if(parseFloat(formData.tds)<0)
            {
                setMsg("Invalid TDS Amount!!!!");
                return;
            }
        }
        if(window.confirm('Are you sure?'))        
        {
            
            setProgress(true);
            if(formData.tds=="") formData.tds=0;
            //console.log(formData);
            let url="/api/Payment/SavePaymentTransaction";            
                await apiClient.post(url,formData).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadTransactions();
                        alert("Payment Details Saved Successfully");
                        setFormData({id:0,facilityid:0,subscriberid:0,accountheadid:0,paymentdate:"",amount:0,tds:0,transactiontype:"",details:""});
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                });   
        }
        setProgress(false);        
    }
    async function loadTransactions()
    {
        //console.log("Token:",localStorage.getItem("token"));
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Payment/GetAllTransactions/"+startDate+"/"+endDate).then(res=>
        {
            if(res.status==200)
            {
                setPaymentData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });        
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/AccountHeads/GetAllHeads").then(res=>
        {
            if(res.status==200)
            {
                setAccountHeads(res.data.data);
            }
        });       
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200)
            {
                setFacilities(res.data.data);
            }
        });
        setProgress(false);   
    }
    async function loadCustomers(event)
    {
        setFormData({...formData,facilityid:event.target.value});
        if(event.target.value=="0" || event.target.value=="")
        {
            setSubscribers([]);
            return;
        }
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Subscription/GetSubscriberByFacility/"+event.target.value).then(res=>
        {
            if(res.status==200)
            {
                let arr=res.data.data;                
                const uniqueArray = Array.from(new Map(arr.map(item => [item.id, item])).values());
                uniqueArray.sort((e1,e2)=>e1.sname.localeCompare(e2.sname));
                setSubscribers([...uniqueArray]);                
            }
        });
        setProgress(false);
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=paymentdata.filter((e)=>e.company.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.name.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.tdetails.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  || e.accounthead.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(paymentdata);                
                setPageData(paymentdata.slice(0,pageSize));
            }
            setPage(1);
        }             
    }    
    async function editPayment(id)
    {
        setProgress(true);
        let facilityid=0;
        let obj={};
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Payment/GetTransactionById/"+id).then(res=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
                
                facilityid=res.data.data.facilityid;
                obj={...res.data.data};                
            }
        });
        if(facilityid>0)
        {
            await apiClient.get(process.env.REACT_APP_APIURL+"/api/Subscription/GetSubscriberByFacility/"+facilityid).then(res=>
            {
                if(res.status==200)
                {
                    let arr=res.data.data;
                    const uniqueArray = Array.from(new Map(arr.map(item => [item.id, item])).values());
                    uniqueArray.sort((e1,e2)=>e1.sname.localeCompare(e2.sname));
                    setSubscribers([...uniqueArray]);                     
                }
            });
        }
        setFormData({...formData,id:obj.id,facilityid:obj.facilityid,subscriberid:obj.subscriberid,accountheadid:obj.accountheadid,paymentdate:obj.tdate.split("T")[0],amount:obj.amount,tds:0,transactiontype:obj.ttype,details:obj.tdetails});                                        
        setProgress(false);
        setShow(true);
    }
    function sortData(colname)
    {
        if(colname=="customer")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1.name.trim().toLowerCase()>e2.name.trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="accounthead" || colname=="ttype" || colname=="tdetails")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="tdate")
        {
            let arr=[...paymentdata];
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[colname]);
                let d2=new Date(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="amount")
        {
            let arr=[...paymentdata];
            arr.sort((e1,e2)=>
            {
                let d1=isNaN(parseFloat(e1[colname]))?0:parseFloat(e1[colname]);
                let d2=isNaN(parseFloat(e2[colname]))?0:parseFloat(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }        
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadTransactions();        
    },[startDate,endDate]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" placeholder="Customer Name/ Company/ Details...." id="searchText" style={{fontSize:'12px',width:'250px'}} onChange={searchData} className="form-control" /></div>                
                <div>
                    <input type="date" value={startDate} onChange={(event)=>setStartDate(event.target.value)} className="form-control form-control-sm" />
                </div>
                <div>&nbsp; to &nbsp;</div>
                <div>
                    <input type="date" value={endDate}  onChange={(event)=>setEndDate(event.target.value)} className="form-control form-control-sm" />
                </div>
                <div className="flex-grow-1 text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addSubsriber} /></div>
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Transaction Details</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={i}>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}
                            <th>View/Edit</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={i}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>
                                {                            
                                    if(ee.key=="customer")
                                    {
                                        return(<td><CustomerDiv cname={e.name} company={e.company} address="" email="" mobile={e.mobile} /></td>);
                                    }
                                    else if(ee.key=="tdate")
                                    {
                                        return(<td>{e[ee.key].split("T")[0].split("-").reverse().join("-")}</td>);                            
                                    }
                                    else
                                    {
                                        return(<td>{e[ee.key]=="Security"?(<>{e[ee.key]} <img src={rcptIcon} onClick={()=>{window.open(process.env.REACT_APP_APIURL+"/api/DownloadInvoice/GetSecurityReceipt/"+e.id,"","width=600px,height=800px")}} style={{width:'30px',cursor:"pointer"}} alt="" /></>):(<>{e[ee.key]}</>)}</td>);                            
                                    }
                                }
                                )}
                                <td className="text-center"><img onClick={()=>editPayment(e.id)} src={editIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>                                
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="1"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="6" className="text-end">
                                Net Debit Amount: &#8377; {paymentdata.reduce((sum,item)=>sum+(item.ttype=="D"?parseFloat(item.amount):0),0)}<br/>
                                Net Credit Amount: &#8377; {paymentdata.reduce((sum,item)=>sum+(item.ttype=="C"?parseFloat(item.amount):0),0)}
                            </th>
                            <th colSpan="1" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="8">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                        
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Transaction Details</div>                                    
                                    <div className="row">
                                            <div className="form-group col-12 mt-2">
                                                <select id="facility" className="form-control" onChange={loadCustomers} value={formData.facilityid}>
                                                    <option value="0">Select Facility</option>
                                                    {facilities.map((e,i)=>
                                                        <option key={"F"+i} value={e.id}>{e.facilityname}</option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-group col-12 mt-2">
                                                <select value={formData.subscriberid} onChange={(option)=>{setFormData({...formData,subscriberid:option.target.value});}} className="form-control">
                                                        <option value="0">Select Customer</option>
                                                        {subscribers.map((e,i)=>(
                                                            <option key={"S"+i} value={e.id}>{e.sname} [{e.company}]</option>
                                                        ))}
                                                </select>                                                
                                            </div>
                                            <div className="form-group col-12 mt-2">
                                                <select className="form-control" value={formData.accountheadid} onChange={(event)=>{setFormData({...formData,accountheadid:event.target.value,tds:event.target.value!="2"?"":"0"});setTDSStatus(event.target.value!="2")}}>
                                                    <option value="0">Select Account Head</option>
                                                    {accountheads.map((e,i)=>
                                                        <option key={"Fc"+i} value={e.id}>{e.headname}</option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Payment Date</label>
                                                <input type="date" className="form-control" value={formData.paymentdate.split("T")[0]} onChange={(event)=>{setFormData({...formData,paymentdate:event.target.value})}} />
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Amount</label>
                                                <input type="number" className="form-control" value={formData.amount} onChange={(event)=>{setFormData({...formData,amount:event.target.value})}} />
                                            </div>
                                            <div>
                                                <label>TDS Amount (if any)</label>
                                                <input type="number" readOnly={tdsstatus} id="tds" className="form-control" value={formData.tds} onChange={(event)=>{setFormData({...formData,tds:event.target.value})}} />
                                            </div>
                                            <div className="form-group col-12 mt-2">
                                                <label>Transaction</label>
                                                <select className="form-control" value={formData.transactiontype} onChange={(event)=>{setFormData({...formData,transactiontype:event.target.value})}}>
                                                    <option value="0">Select Transaction Type</option>
                                                    <option value="C">Payment Received</option>
                                                    <option value="D">Payment Paid</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-12">
                                                <label>Transaction Details</label>
                                                <textarea className="form-control" value={formData.details} onChange={(event)=>{setFormData({...formData,details:event.target.value})}} value={formData.details}></textarea>    
                                            </div>
                                    </div>    
                                    <input type="button" className="btn btn-danger mt-2"  onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default Payments;